<template lang="pug">
    div.heroContent(v-if="heroItem && JSON.stringify(heroItem)!=='{}'")
        div.headBox
            img(alt="", :src="require('../assets/hero_icon/'+heroItem.heroIcon)")
        div.heroName {{heroItem.heroName}}
        div.weaponInfoBox
            div.content
                span.contentTitle {{$t("heroContent.weaponInfoBoxTitle")}}
                div.weaponIconBg
                    div.weaponIcon
                        img(alt="", :src="require('../assets/weapon_icon/'+heroItem.weaponIcon)")
        div.heroInfoBox
            div.content
                span.contentTitle {{$t("heroContent.heroInfoBoxTitle")}}
                div#heroInfo
                    div(v-for="(item, index) in heroItem.heroInfo", :key="index", class="heroInfoItem")
                        div#heroLevel
                            img(alt="", :src="require('../assets/level'+heroItem.heroInfo[index].level+'.png')")
                        div#heroRight
                            div(v-if="heroItem.heroInfo[index].atk != '' && heroItem.heroInfo[index].atk != '-' && heroItem.heroInfo[index].atk != '0'") ATK+{{heroItem.heroInfo[index].atk}}
                            div(v-if="heroItem.heroInfo[index].describe != '' && heroItem.heroInfo[index].describe != '-' && heroItem.heroInfo[index].describe != '0'")
                                img(alt="", :src="require('../assets/hero_skill_icon/'+heroItem.heroInfo[index].describeSkillIcon)")
                                span {{heroItem.heroInfo[index].describe}}
                            div(v-if="heroItem.heroInfo[index].attributes != '' && heroItem.heroInfo[index].attributes != '-' && heroItem.heroInfo[index].attributes != '0'")
                                img(alt="", :src="require('../assets/hero_skill_icon/'+heroItem.heroInfo[index].attributesSkillIcon)")
                                span {{heroItem.heroInfo[index].attributes}}
</template>
  
<script>
export default {
    name: 'HeroContent',
    data() {
        return {
            heroId:"",
            heroItem:{},
            heroItemList:[]
        }
    },
    created() {
        
    },
    methods:{
        retrieveData(){
            for(let i = 0; i < this.heroItemList.length; i++){
                if(this.heroItemList[i].heroId == this.heroId){
                    this.heroItem = this.$t("heroItemList["+i+"]")
                }
            }
        }
    },
    components:{

    },
    mounted() {
        let wikiData = require("../assets/lang/zh_CN.json")
        this.heroItemList = wikiData.heroItemList
        this.heroId = this.$route.params.id
        this.$nextTick(() => {
            this.retrieveData()
        })
    }
}
</script>

<style lang="scss">
#app{
    background-color: #1c1f1f;
    background: url("../assets/foot_bg.png") center bottom no-repeat;
    background-size: contain;
}
.heroContent {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    background: url("../assets/weapon_icon_bg.png") center top no-repeat;
    background-size: contain;
    .headBox {
        margin-top: 20px;
        width: 150.46px;
        height: 213.94px;
    }
    .headBox img {
        width: 100%;
        height: 100%;
    }
    .heroName {
        margin-top: 40px;
        width: 100%;
        text-indent: 5%;
        font-size: 32px;
        font-weight: bold;
        color: #dceae3;
    }
    .heroInfoBox {
        margin: 22px 0;
        width: 90%;
        color: #dceae3;
    }
    .weaponInfoBox {
        margin-top: 22px;
        width: 90%;
        color: #dceae3;
    }
    .weaponInfoBox .content {
        min-height: 0;
        display: flex;
        background-size: cover;
    }
    .weaponInfoBox .contentTitle {
        align-self: center;
        margin: 15px 0;
        padding-left: 8%;
        width: 75%;
        height: 100%;
        font-size: 20px;
        background: url("../assets/title_icon.png") 6% center no-repeat;
        background-size: contain;
    }
    .weaponIconBg {
        float: right;
        margin: 10px 10px 10px  0;
        width: 50.54px;
        height: 66.78px;
        background: url("../assets/weapon_icon_box_bg.png") center no-repeat;
        background-size: contain;
    }
    .weaponIcon {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 100%;
        height: 100%;
    }
    .weaponIcon img {
        width: 80%;
        height: 80%;
    }
    .content {
        float: left;
        width: 100%;
        min-height: 124px;
        background: url("../assets/content_bg.png") top center no-repeat;
        background-size: contain;
        background-color: rgba(0,0,0,0.7);
        border: 1px #212322 solid;
    }
    .contentTitle {
        float: left;
        margin: 15px 0;
        padding-left: 8%;
        width: 92%;
        font-size: 20px;
        line-height: 18px;
        background: url("../assets/title_icon.png") 5% center no-repeat;
        background-size: contain;
    }
    .heroInfoItem {
        float: left;
        position: relative;
        margin: 0 0 0 5%;
        width: 90%;
        border-top: 2px #262a27 solid;
    }
    .heroInfoItem:last-child {
        margin-bottom: 20px;
        border-bottom: 2px #262a27 solid;
    }
    #heroLevel {
        float: left;
        position: absolute;
        top: 0;
        bottom: 0;
        margin: 0;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 30%;
        font-size: 14px;
        text-align: left;
        color: #dceae3;
    }
    #heroLevel img {
        width: 90%;
        justify-content: center;
        align-items: center;
        border: none;
        display: flex;
    }
    #heroRight {
        float: right;
        margin: 0;
        width: 69%;
        border-left: 1px #262a27 solid;
        border-top: none;
        font-size: 14px;
        text-align: left;
        color: #dceae3;
    }
    #heroRight div {
        display: flex;
        //justify-content: center;
        align-items: center;
        padding: 5px 10px;
        border-bottom: 1px #262a27 solid;
    }
    #heroRight div:last-child {
        border-bottom: 0;
    }
    #heroRight div img {
        padding-right: 10px;
        width: 37.28px;
    }
}
</style>